// Runtime flags shared across the app. Mirrors midani-frontend's config so the
// encryption/handshake flow behaves identically here.

export const SKIP_ENCRYPT = process.env.REACT_APP_SKIP_ENCRYPT === 'true';

// How many times App will attempt the startup handshake before giving up.
export const HAND_SHAKE_MAX_RETRY = 1;
